// apps/web/src/constants/permissions.js

export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',

  CLIENTS_VIEW: 'clients.view',
  CLIENTS_MANAGE: 'clients.manage',

  USERS_VIEW: 'users.view',
  USERS_MANAGE: 'users.manage',

  FORMS_VIEW: 'forms.view',
  FORMS_MANAGE: 'forms.manage',

  LEADS_VIEW: 'leads.view',
  LEADS_EXPORT: 'leads.export',

  EVENTS_VIEW: 'events.view',
  EVENTS_MANAGE: 'events.manage',

  GAMES_VIEW: 'games.view',
  GAMES_MANAGE: 'games.manage',

  PRIZES_VIEW: 'prizes.view',
  PRIZES_MANAGE: 'prizes.manage',

  INVENTORY_VIEW: 'inventory.view',
  INVENTORY_MANAGE: 'inventory.manage',

  DAILY_LIMITS_VIEW: 'daily-limits.view',
  DAILY_LIMITS_MANAGE: 'daily-limits.manage',

  SPINS_VIEW: 'spins.view',

  REPORTS_VIEW: 'reports.view',
  REPORTS_EXPORT: 'reports.export',

  SETTINGS_VIEW: 'settings.view',
  SETTINGS_MANAGE: 'settings.manage',
}

export const ALL_PERMISSIONS = Object.values(PERMISSIONS)

export const PERMISSION_GROUPS = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    permissions: [
      {
        value: PERMISSIONS.DASHBOARD_VIEW,
        label: 'Visualizar dashboard',
      },
    ],
  },
  {
    key: 'clients',
    title: 'Clientes',
    permissions: [
      {
        value: PERMISSIONS.CLIENTS_VIEW,
        label: 'Visualizar clientes',
      },
      {
        value: PERMISSIONS.CLIENTS_MANAGE,
        label: 'Gerenciar clientes',
      },
    ],
  },
  {
    key: 'users',
    title: 'Usuários',
    permissions: [
      {
        value: PERMISSIONS.USERS_VIEW,
        label: 'Visualizar usuários',
      },
      {
        value: PERMISSIONS.USERS_MANAGE,
        label: 'Criar, editar e remover usuários',
      },
    ],
  },
  {
    key: 'forms',
    title: 'Formulários',
    permissions: [
      {
        value: PERMISSIONS.FORMS_VIEW,
        label: 'Visualizar formulários',
      },
      {
        value: PERMISSIONS.FORMS_MANAGE,
        label: 'Gerenciar formulários',
      },
    ],
  },
  {
    key: 'leads',
    title: 'Leads',
    permissions: [
      {
        value: PERMISSIONS.LEADS_VIEW,
        label: 'Visualizar leads',
      },
      {
        value: PERMISSIONS.LEADS_EXPORT,
        label: 'Exportar leads',
      },
    ],
  },
  {
    key: 'events',
    title: 'Eventos',
    permissions: [
      {
        value: PERMISSIONS.EVENTS_VIEW,
        label: 'Visualizar eventos',
      },
      {
        value: PERMISSIONS.EVENTS_MANAGE,
        label: 'Gerenciar eventos',
      },
    ],
  },
  {
    key: 'games',
    title: 'Jogos',
    permissions: [
      {
        value: PERMISSIONS.GAMES_VIEW,
        label: 'Visualizar jogos',
      },
      {
        value: PERMISSIONS.GAMES_MANAGE,
        label: 'Gerenciar jogos',
      },
    ],
  },
  {
    key: 'prizes',
    title: 'Brindes',
    permissions: [
      {
        value: PERMISSIONS.PRIZES_VIEW,
        label: 'Visualizar brindes',
      },
      {
        value: PERMISSIONS.PRIZES_MANAGE,
        label: 'Gerenciar brindes',
      },
    ],
  },
  {
    key: 'inventory',
    title: 'Estoque',
    permissions: [
      {
        value: PERMISSIONS.INVENTORY_VIEW,
        label: 'Visualizar estoque',
      },
      {
        value: PERMISSIONS.INVENTORY_MANAGE,
        label: 'Movimentar e ajustar estoque',
      },
    ],
  },
  {
    key: 'daily-limits',
    title: 'Limites Diários',
    permissions: [
      {
        value: PERMISSIONS.DAILY_LIMITS_VIEW,
        label: 'Visualizar limites diários',
      },
      {
        value: PERMISSIONS.DAILY_LIMITS_MANAGE,
        label: 'Criar, editar e excluir limites',
      },
    ],
  },
  {
    key: 'spins',
    title: 'Jogadas',
    permissions: [
      {
        value: PERMISSIONS.SPINS_VIEW,
        label: 'Visualizar jogadas',
      },
    ],
  },
  {
    key: 'reports',
    title: 'Relatórios',
    permissions: [
      {
        value: PERMISSIONS.REPORTS_VIEW,
        label: 'Visualizar relatórios',
      },
      {
        value: PERMISSIONS.REPORTS_EXPORT,
        label: 'Exportar relatórios',
      },
    ],
  },
  {
    key: 'settings',
    title: 'Configurações',
    permissions: [
      {
        value: PERMISSIONS.SETTINGS_VIEW,
        label: 'Visualizar configurações',
      },
      {
        value: PERMISSIONS.SETTINGS_MANAGE,
        label: 'Alterar configurações',
      },
    ],
  },
]

export const getDefaultPermissionsByClientRole = (clientRole) => {
  if (clientRole === 'ADMIN') {
    return [...ALL_PERMISSIONS]
  }

  if (clientRole === 'OPERATOR') {
    return [
      PERMISSIONS.DASHBOARD_VIEW,

      PERMISSIONS.EVENTS_VIEW,
      PERMISSIONS.GAMES_VIEW,
      PERMISSIONS.PRIZES_VIEW,

      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.INVENTORY_MANAGE,

      PERMISSIONS.DAILY_LIMITS_VIEW,
      PERMISSIONS.DAILY_LIMITS_MANAGE,

      PERMISSIONS.SPINS_VIEW,
    ]
  }

  return [
    PERMISSIONS.DASHBOARD_VIEW,

    PERMISSIONS.EVENTS_VIEW,
    PERMISSIONS.GAMES_VIEW,
    PERMISSIONS.PRIZES_VIEW,

    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.DAILY_LIMITS_VIEW,

    PERMISSIONS.SPINS_VIEW,
    PERMISSIONS.REPORTS_VIEW,
  ]
}

export const getPermissionLabel = (permissionValue) => {
  for (const group of PERMISSION_GROUPS) {
    const permission = group.permissions.find(
      (item) => item.value === permissionValue,
    )

    if (permission) {
      return permission.label
    }
  }

  return permissionValue
}